import { vueRoutes } from '@/vue-router/routes'

export const NAVIGATION = [
  {
    name: 'dash',
    className: 'sidebar__link-icon mdi mdi-cogs',
    to: vueRoutes.dashboard,
    title: 'pages-names.dash',
  },
  {
    name: 'logs',
    className: 'sidebar__link-icon mdi mdi-format-list-bulleted',
    to: vueRoutes.logs,
    title: 'pages-names.logs',
  },
  {
    name: 'announcements',
    className: 'sidebar__link-icon mdi mdi-playlist-check',
    to: vueRoutes.announcements,
    title: 'pages-names.announcements',
  },
  {
    name: 'admins',
    className: 'sidebar__link-icon mdi mdi-account-multiple-plus',
    to: vueRoutes.admins,
    title: 'pages-names.admins',
  },
  {
    name: 'businesses',
    className: 'sidebar__link-icon mdi mdi-account-tie',
    to: vueRoutes.businesses,
    title: 'pages-names.businesses',
  },
  {
    name: 'users',
    className: 'sidebar__link-icon mdi mdi-account',
    to: vueRoutes.users,
    title: 'pages-names.users',
  },
  {
    name: 'verifications',
    className: 'sidebar__link-icon mdi mdi-account-plus',
    to: vueRoutes.verifications,
    title: 'pages-names.verifications',
  },
  {
    name: 'supported-networks-page',
    className: 'sidebar__link-icon mdi mdi-folder-key-network',
    to: vueRoutes.supportedNetworks,
    title: 'pages-names.supported-networks',
  },
  {
    name: 'quickbuy',
    className: 'sidebar__link-icon mdi mdi-currency-eur',
    to: vueRoutes.quickbuy,
    title: 'pages-names.quickbuy',
  },
  {
    name: 'roles',
    className: 'sidebar__link-icon mdi mdi-table-settings',
    to: vueRoutes.roles,
    title: 'pages-names.roles',
  },
  {
    name: 'admin-actions',
    className: 'sidebar__link-icon mdi mdi-cogs',
    to: vueRoutes.adminActions,
    title: 'pages-names.admin-actions',
  },
  {
    name: 'widget-access-keys',
    className: 'sidebar__link-icon mdi mdi-shield-key',
    to: vueRoutes.widgetAccessKeys,
    title: 'pages-names.widget-access-keys',
  },
  {
    name: 'feature-flags',
    className: 'sidebar__link-icon mdi mdi-flag',
    to: vueRoutes.featureFlags,
    title: 'pages-names.feature-flags',
  },
  {
    name: 'permission-transactions',
    className: 'sidebar__link-icon mdi mdi-apps',
    to: vueRoutes.permissionTransactions,
    title: 'pages-names.permission-transactions',
  },
]
